import { Box, FormLabel, Grid, MenuItem, Select, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Periodo = () => {
  const { promptData, setPromptData} = useActividadesContext();

  const handleFrecuenciaChange = (event) => {
    const selectedFrecuencia = event.target.value;
    
    setPromptData((prevData) => ({
      ...prevData,
      periodo: selectedFrecuencia
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color:'#336B87' }}>
            Periodo *
          </Typography>
        </Box>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Selecciona el lapso de tiempo al que corresponde el informe.
        </FormLabel>
        <Select
          fullWidth
          value={promptData.periodo}
          onChange={handleFrecuenciaChange}
          displayEmpty
          variant="outlined"
          sx={{
            fontFamily: 'montserrat',
            mb: 2,
            fontSize: '0.75rem',
            color: '#336B87',
            '& fieldset': { borderColor: '#Divider' },
            '&:before': { borderColor: '#Divider' },
            '&:after': { borderColor: '#Divider' }
          }}
        >
          <MenuItem value="" disabled sx={{ fontFamily: 'montserrat', fontSize: '0.8rem' }}>
            Selecciona una opción
          </MenuItem>
          <MenuItem value="mensual" sx={{ fontFamily: 'montserrat', fontSize: '0.8rem' }}>Mensual</MenuItem>
          <MenuItem value="bimestral" sx={{ fontFamily: 'montserrat', fontSize: '0.8rem' }}>Bimestral</MenuItem>
          <MenuItem value="trimestral" sx={{ fontFamily: 'montserrat', fontSize: '0.8rem' }}>Trimestral</MenuItem>
          <MenuItem value="semestral" sx={{ fontFamily: 'montserrat', fontSize: '0.8rem' }}>Semestral</MenuItem>
          <MenuItem value="anual" sx={{ fontFamily: 'montserrat', fontSize: '0.8rem' }}>Anual</MenuItem>
        </Select>
      </Box>
    </Grid>
  );
};

export default Periodo;
